// extracted by mini-css-extract-plugin
export default {"section":"PlansSection_section__GIBVO","wrapper":"PlansSection_wrapper__5FlrM","linkWrapper":"PlansSection_linkWrapper__QAkx2","link":"PlansSection_link__sTW2v"};